import { render, staticRenderFns } from "./FreightPrice.vue?vue&type=template&id=46b5db25"
import script from "./FreightPrice.vue?vue&type=script&lang=js"
export * from "./FreightPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightPrice.vue
// module id = 2309
// module chunks = 31